<template>
  <div>
    <button @click="showPopup = true" class="ai-button">
      <img src="@/assets/ai-icon.png" alt="Castive AI" class="w-9 h-10">
    </button>
    <div v-if="showPopup" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
      <div class="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full text-center">
        <h3 class="text-lg font-bold text-gray-900">Castive AI</h3>
        <p class="mt-2 text-sm text-gray-600">This feature is coming soon! Automated show notes and transcripts are already live, but there's much more coming soon! - powered by cutting-edge AI.</p>
        <div class="mt-6"><button @click="showPopup = false" class="px-6 py-2 bg-brand-purple-dark text-white rounded-md hover:opacity-90">Got it!</button></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingAiButton',
  data() {
    return {
      showPopup: false,
    };
  },
};
</script>

<style scoped>
.ai-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  
  background: transparent;
  border: none;
  cursor: pointer;
  
  width: 80px;
  height: 80px;
  
  padding: 8px;
  border-radius: 50%;
  
  transition: transform 0.2s ease-in-out, filter 0.2s ease-in-out;
}

.ai-button:hover {
  transform: scale(1.1);
  filter: drop-shadow(0 0 10px theme('colors.brand.purple-dark'));
}
</style>